import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitEarlyAccess = (data) => api.post("/early-access", data).then((r) => r.data);
export const submitBusinessEnquiry = (data) => api.post("/business-enquiry", data).then((r) => r.data);
export const submitInvestorEnquiry = (data) => api.post("/investor-enquiry", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
